import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useUser } from "@/context/UserContext";

const Splash = () => (
  <div className="flex min-h-screen items-center justify-center bg-[#0D1B2A]">
    <Loader2 className="h-6 w-6 animate-spin text-[#C5A059]" />
  </div>
);

export const ProtectedRoute = ({ children }) => {
  const { currentUser, loading } = useUser();
  if (loading) return <Splash />;
  if (!currentUser) return <Navigate to="/login" replace />;
  return children;
};

export const AreaRoute = ({ area, children }) => {
  const { currentUser, loading, can } = useUser();
  const location = useLocation();
  if (loading) return <Splash />;
  if (!currentUser) return <Navigate to="/login" replace />;
  if (area && !can(area)) return <Navigate to="/" replace state={{ denied: location.pathname }} />;
  return children;
};

export const AdminRoute = ({ children }) => {
  const { currentUser, loading, isAdmin } = useUser();
  if (loading) return <Splash />;
  if (!currentUser) return <Navigate to="/login" replace />;
  if (!isAdmin) return <Navigate to="/" replace />;
  return children;
};

export const OnboardedGate = ({ children }) => {
  const { currentUser } = useUser();
  if (currentUser?.must_reset) return <Navigate to="/change-password" replace />;
  return children;
};
